import { useState, useEffect } from "react";

export function useNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Lock body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  // STATE: Gelap jika discroll ATAU menu sedang terbuka
  const isDarkState = scrolled || isMenuOpen;

  const navClasses = {
    // Container: Putih saat scroll/menu open, Transparan saat di atas
    container: `fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ease-in-out ${
      isDarkState ? "bg-white shadow-sm py-4" : "bg-transparent py-6"
    }`,

    // Icon & Text Menu: Hitam saat scroll/menu open, Putih saat di atas
    text: isDarkState ? "text-black" : "text-white",

    // Logo: Hitam saat scroll/menu open, Putih saat di atas
    logoColor: isDarkState ? "text-black" : "text-white",

    // Tombol Book Now:
    // Saat Scrolled/Open: Background Emas, Text Putih (Mewah)
    // Saat Top: Background Putih, Text Hitam (Agar kontras dengan video gelap)
    button: isDarkState
      ? "bg-brand-gold text-white hover:bg-brand-gold-dark"
      : "bg-white text-black hover:bg-white/90",
  };

  return {
    scrolled,
    isMenuOpen,
    setIsMenuOpen,
    navClasses,
  };
}
